<template style="height:100%">
  <div class="Chart_add">
    <el-form ref="form" :model="form" label-width="80px" style="padding-top: 20px;margin-left: 20px;">
      <el-form-item label="量表名称">
        <el-input placeholder="量表名称" v-model="form.a1" :disabled="true">
          <template slot="append" > <span style="cursor: pointer;" @click="cel()">选择量表</span></template>
        </el-input>
      </el-form-item>
      <el-form-item label="统计图表名称">
        <el-input placeholder="量表名称" v-model="form.a1" >
        </el-input>
      </el-form-item>

      <el-form-item label="排序">
        <el-input placeholder="排序" v-model="form.a1" >
        </el-input>
      </el-form-item>

      <el-form-item label="开始维度">
        <el-input placeholder="开始维度" v-model="form.a1" >
        </el-input>
      </el-form-item>

      <el-form-item label="结束维度">
        <el-input placeholder="结束维度" v-model="form.a1" >
        </el-input>
      </el-form-item>

      <el-form-item label="颜色">
        <el-select v-model="form.a2" placeholder="颜色">
          <el-option label="区域一" value="shanghai"></el-option>
          <el-option label="区域二" value="beijing"></el-option>
          <el-option label="区域三" value="HENAN"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="是否启用:">
        <el-checkbox-group v-model="form.a1">
          <el-checkbox label="是" name="type"></el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-button type="primary">新增</el-button>
    </el-form>

    <el-dialog class="cscs" :visible.sync="dialogVisible" width="600px" style="height: 700px;" :before-close="handleClose">
      <el-input v-model="a2" placeholder="量表代号"></el-input>
      <el-button type="primary" style="margin-left:20px">搜索</el-button>
      <scales_Pop @sendmsg="getmsg"></scales_Pop>
    </el-dialog>
    
  </div>
</template>
<script>
import scales_Pop from '@/components/scales_Pop.vue'
  export default {
    data() {
      return {
        dialogVisible:false,
        a2:'',
        form: {
          a1:'',
          a2:'',
          a3:'',
          a4:'',
          a5:'',
          a6:'',
          a7:'',
        }
      };
    },
    components:{
      scales_Pop,
    },
    methods: {
      cel(){
        this.dialogVisible = true;
      },
      getmsg(val){//量表点击时子组件传过来值
        console.log(val);
      },
      handleClose(done) {
        this.$confirm('确认关闭？').then(_ => {
          done();
        })
        .catch(_ => {});
      }
    }
  };
</script>
<style>
.Chart_add{width: 100%;height: 100%;background-color: #fff;}
.Chart_add .el-input, .el-textarea{width: 300px;}
.Chart_add .cscs .el-input, .el-textarea{width: 200px;}
</style>